//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Input from './Input';
import DateTimeModel from '../../mixins/DateTimeModel';

export default {
    extends: Input,

    mixins: [
        DateTimeModel,
    ],

    props: {
        value: Number,
        datetime: Boolean,
        minDate: Number,
        maxDate: Number,
        defaultTime: String,
        disabledDates: [Date, Object, Array],
        clearable: Boolean,
        autoOpen: Boolean,
        autoClose: Boolean,
        pageDate: Number,
    },

    computed: {
        format() {
            return this.datetime ? $.dateTimeFormat : $.dateFormat;
        },
        formattedModel: {
            get() {
                return !this.model ? null : dayjs(this.model).format(this.format);
            },
            set(value) {
                this.model = !value ? null : dayjs(value, this.format).valueOf();
            },
        },
        pageDate_() {
            return this.pageDate && new Date(this.pageDate);
        },
    },

    methods: {
        open() {
            this.$refs.container.click();
        },
        close() {
            this.$refs.popup.close();
        },
        onInput() {
            if (this.autoClose && this.$refs.popup.status === 'show') {
                this.$nextTick(() => {
                    this.close();
                });
            }
        },
    },

    mounted() {
        if (this.autoOpen) {
            this.open();
        }
    },
};
